import React from 'react'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin'
import AddIcon from '@mui/icons-material/Add'
import { PayoutMethodResponseDto } from '../DepositWithdrawModal'

type ProviderStepProps = {
    selectedPayoutMethodId: string | null
    setSelectedPayoutMethodId: (id: string | null) => void
    payoutMethods: PayoutMethodResponseDto[]
    onAddNewMethod: () => void
}

const ProviderStep: React.FC<ProviderStepProps> = ({
                                                       selectedPayoutMethodId,
                                                       setSelectedPayoutMethodId,
                                                       payoutMethods,
                                                       onAddNewMethod,
                                                   }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {payoutMethods.map((method) => {
                const isSelected = selectedPayoutMethodId === method.id

                return (
                    <button
                        key={method.id}
                        onClick={() => setSelectedPayoutMethodId(isSelected ? null : (method.id ?? null))}
                        className={`relative rounded-xl p-4 border text-left transition-all ${
                            isSelected ? 'border-blue-500 ring-2 ring-blue-500 bg-blue-500/5' : 'border-gray-400 hover:border-gray-300'
                        }`}
                    >
                        <div className="absolute top-2 right-2 text-xs bg-gray-800 px-2 py-0.5 rounded">
                            {method.isDefault ? 'Default' : method.methodType}
                        </div>

                        <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center mb-3">
                            {method.methodType === 'BANK' && <AccountBalanceIcon className="text-green-500"/>}
                            {method.methodType === 'CARD' && <CreditCardIcon className="text-blue-500"/>}
                            {method.methodType === 'CRYPTO' && <CurrencyBitcoinIcon className="text-yellow-500"/>}
                        </div>

                        <div className="font-semibold">
                            {method.methodType === 'BANK' && `Bank Account (${method.iban ?? '****'})`}
                            {method.methodType === 'CARD' && `${method.brand ?? 'Card'} (...${method.last4 ?? ''})`}
                            {method.methodType === 'CRYPTO' && `Crypto Wallet (${method.network ?? 'Network'})`}
                        </div>

                        <div className="text-xs text-gray-400 mt-1">
                            {method.methodType === 'BANK' && `BIC / Bank: ${method.bic ?? 'N/A'}`}
                            {method.methodType === 'CARD' && `Tokenized Card`}
                            {method.methodType === 'CRYPTO' && `Address: ${method.walletAddress?.substring(0, 6)}...`}
                        </div>
                    </button>
                )
            })}

            <button
                onClick={onAddNewMethod}
                className="rounded-xl p-4 border border-dashed border-gray-500 text-left hover:border-blue-400 flex flex-col items-center justify-center min-h-[110px] text-gray-400 hover:text-blue-400 transition-colors"
            >
                <div className="w-10 h-10 rounded-lg bg-gray-800 flex items-center justify-center mb-2">
                    <AddIcon/>
                </div>
                <div className="font-semibold text-sm">Add New Payout Method</div>
            </button>
        </div>
    )
}

export default ProviderStep